<template>
  <div class="million-read-book-list"
       :class="`type-${type}`"
  >
    <book-list-item v-for="(item, index) in list"
                    :key="index"
                    :item="item"
                    :type="type"
                    :select-all="selectAll"
                    :show-manage="showManage"
                    @select-book="handleSelectBook"
    />
  </div>
</template>

<script>
  import BookListItem from '@/pages/MillionRead/components/BookListItem';

  export default {
    name: 'MillionReadBookList',
    components: {
      BookListItem,
    },
    props: {
      list: {
        type: Array,
        required: true,
      },
      showManage: {
        type: Boolean,
        default: false,
      },
      selectAll: {
        type: Boolean,
      },
      type: {
        type: String,
        default: 'small',
        validator(val) {
          return [
            'extra-small',
            'small',
            'normal',
          ].includes(val);
        },
      },
    },
    data() {
      return {
        selectIdList: [],
      };
    },
    methods: {
      handleSelectBook(id) {
        this.$emit('manage-book', id);
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .million-read-book-list {
    padding: @size-large @size-base;
    &-item {
      &:not(:last-child) {
        margin-bottom: @size-large;
      }
    }

    &.type-extra-small {
      padding: @size-medium 0 0 @size-base;
      .million-read-book-list-item {
        &:not(:last-child) {
          margin-bottom: @size-medium;
        }
      }
    }
  }

</style>
